import gql from 'graphql-tag';
import { COMMENT_TYPE } from './CommentType.gql';

export const DELETE_USER_COMMENT = gql`
  ${COMMENT_TYPE}
  mutation deleteUserComment($commentId: ID!) {
    deleteUserComment(commentId: $commentId) {
      comment {
        ...CommentType
      }
    }
  }
`;
